module.exports = __webpack_public_path__ + "static/media/HCRA Compliance Order - Pinetree Developments Inc. - May 5, 2023.3927a3d5.pdf";